import { useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';

const STORAGE_KEY = 'portal_unlocked';

function getUnlocked(): boolean {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export default function PasswordGate({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const [unlocked, setUnlocked] = useState(getUnlocked);
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);

  const expected = import.meta.env.VITE_PORTAL_PASSWORD as string | undefined;
  const isPublicRoute = location.pathname === '/register' || location.pathname === '/login';
  const gateOpen = isPublicRoute || !expected || unlocked;

  const submit = useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();
      setError(null);
      if (password === expected) {
        try {
          sessionStorage.setItem(STORAGE_KEY, '1');
        } catch {}
        setUnlocked(true);
      } else {
        setError('Incorrect password');
      }
    },
    [password, expected]
  );

  if (gateOpen) return <>{children}</>;

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-charcoal p-4">
      <div className="w-full max-w-sm rounded-xl border border-leather bg-leather/40 p-6">
        <h1 className="text-xl font-semibold text-gold mb-2">Portal access</h1>
        <p className="text-station-muted text-sm mb-4">Enter the portal password to continue.</p>
        <form onSubmit={submit} className="space-y-3">
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className="w-full rounded-lg border border-leather bg-leather/30 px-3 py-2 text-white placeholder-station-muted focus:ring-2 focus:ring-gold focus:border-gold"
            autoFocus
          />
          {error && <p className="text-red-400 text-sm">{error}</p>}
          <button
            type="submit"
            className="w-full rounded-lg bg-gold text-charcoal font-medium py-2.5 hover:bg-gold/90 transition-colors"
          >
            Continue
          </button>
        </form>
      </div>
    </div>
  );
}
